import React, { useState, useEffect } from "react";
import SidebarLayout from "../../components/sidebarLayout";
import Footer from "../../components/footer";
import NavigationBar from "../../components/navbar";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import { Table, Pagination } from "react-bootstrap";
import { Link } from "react-router-dom"; // 상세 페이지로 이동을 위한 Link
import axios from "axios"; // axios 추가
import "./project.css";

const ITEMS_PER_PAGE = 10; // 페이지당 항목 수

export default function Project() {
  const projectMenu = menuData.find((menu) => menu.title === "주요사업");
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const [projects, setProjects] = useState([]); // 공지사항 데이터
  const [totalPages, setTotalPages] = useState(1); // 총 페이지 수
  const [loading, setLoading] = useState(true); // 로딩 상태

  // 공지사항 데이터 가져오기
  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/api/project/list", {
          params: { page: currentPage, size: ITEMS_PER_PAGE },
        });

        const data = Array.isArray(response.data.data)
          ? response.data.data
          : []; // 데이터가 배열인지 확인 후 설정

        setProjects(data); // 공지사항 데이터 설정
        setTotalPages(Math.ceil(data.length / ITEMS_PER_PAGE)); // 총 페이지 수 계산
      } catch (error) {
        console.error("Error fetching projects:", error);
        setProjects([]);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [currentPage]);

  // 페이지 변경 핸들러
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <SidebarLayout menu={projectMenu}>
        <Table className="project-table" striped hover>
          <thead>
            <tr>
              <th className="text-center" style={{ width: "10%" }}>
                번호
              </th>
              <th>제목</th>
              <th className="text-center" style={{ width: "15%" }}>
                날짜
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" className="text-center">
                  로딩 중...
                </td>
              </tr>
            ) : (
              projects.map((project, index) => (
                <tr key={project.id}>
                  <td className="text-center">
                    {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                  </td>
                  <td>
                    <Link
                      to={`/project/${project.projectId}`}
                      className="project-link"
                    >
                      {project.title}
                    </Link>
                  </td>
                  <td className="text-center">
                    {new Date(project.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {/* 페이지네이션 */}
        <Pagination className="justify-content-center mt-4">
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </SidebarLayout>
    </div>
  );
}
